import React from 'react'

export const SundaySchedule: React.FC = () => {
  return (
    <div
      id="sunday-schedule"
      className="bg-white rounded-lg shadow-lg p-4 md:p-6"
    >
      <h3 className="sticky top-0 z-10 bg-white text-xl md:text-2xl font-serif text-[#3C2416] mb-4 py-2 -mx-4 px-4 md:static md:mx-0 md:px-0 md:py-0">
        Sunday · July 20 — Arrivals & Opening Reception
      </h3>

      {/* Mobile Version */}
      <div className="md:hidden space-y-4">
        <div className="border-b border-gray-200 pb-4 last:border-b-0">
          <div className="text-sm font-bold text-white bg-[#142841] px-3 py-2 rounded-t-lg">
            6:00 – 8:00 PM
          </div>
          <div className="p-3 bg-gray-50 rounded-b-lg">
            <div className="p-3 rounded-lg bg-white border-l-4 border-[#3C2416] text-center font-bold">
              <div className="text-xs font-semibold mb-1 opacity-75">
                Pinnacle
              </div>
              Opening Reception
            </div>
          </div>
        </div>
      </div>

      {/* Desktop Version */}
      <div className="hidden md:grid grid-cols-[minmax(11rem,_auto)_1fr_1fr] w-full text-sm border-t border-l border-gray-300">
        {/* Headers */}
        <div className="text-center py-2 px-2 text-white font-bold bg-[#142841] border-b border-gray-300">
          Time
        </div>
        <div className="text-left py-2 px-2 text-[#3C2416] font-bold border-b border-gray-300">
          Pinnacle
        </div>
        <div className="text-left py-2 px-2 text-[#3C2416] font-bold border-b border-gray-300">
          Notes
        </div>
        {/* Row */}
        <div className="py-2 px-2 bg-[#142841] text-white font-bold text-center border-b border-gray-300">
          6:00 – 8:00 PM
        </div>
        <div className="py-2 px-2 text-center font-bold border-b border-gray-300">
          Opening Reception
        </div>
        <div className="py-2 px-2 border-b border-gray-300" />
      </div>
    </div>
  )
}

export const MondaySchedule: React.FC = () => {
  return (
    <div
      id="monday-schedule"
      className="bg-white rounded-lg shadow-lg p-4 md:p-6"
    >
      <h3 className="sticky top-0 z-10 bg-white text-xl md:text-2xl font-serif text-[#3C2416] mb-4 py-2 -mx-4 px-4 md:static md:mx-0 md:px-0 md:py-0">
        Monday · July 21 — Kick-off & Consensus Launch
      </h3>

      {/* Mobile Version */}
      <div className="md:hidden space-y-4">
        <div className="border-b border-gray-200 pb-4">
          <div className="text-sm font-bold text-white bg-[#142841] px-3 py-2 rounded-t-lg">
            8:00 – 9:00 AM
          </div>
          <div className="p-3 bg-gray-50 rounded-b-lg">
            <div className="p-3 rounded-lg bg-white border-l-4 border-[#3C2416] text-center font-bold">
              Breakfast (Pinnacle)
            </div>
          </div>
        </div>

        <div className="border-b border-gray-200 pb-4">
          <div className="text-sm font-bold text-white bg-[#142841] px-3 py-2 rounded-t-lg">
            9:00 – 10:00 AM
          </div>
          <div className="p-3 bg-gray-50 rounded-b-lg">
            <div className="p-3 rounded-lg bg-white border-l-4 border-[#3C2416]">
              <div className="text-xs font-semibold mb-1 opacity-75">
                Pinnacle
              </div>
              Welcome
            </div>
          </div>
        </div>

        <div className="border-b border-gray-200 pb-4">
          <div className="text-sm font-bold text-white bg-[#142841] px-3 py-2 rounded-t-lg">
            10:00 – 10:45 AM
          </div>
          <div className="p-3 bg-gray-50 rounded-b-lg">
            <div className="p-3 rounded-lg bg-white border-l-4 border-[#3C2416]">
              <div className="text-xs font-semibold mb-1 opacity-75">
                Pinnacle
              </div>
              NASCC Updates (Everyone)
            </div>
          </div>
        </div>

        <div className="border-b border-gray-200 pb-4">
          <div className="text-sm font-bold text-white bg-[#142841] px-3 py-2 rounded-t-lg">
            10:45 – 11:15 AM
          </div>
          <div className="p-3 bg-gray-50 rounded-b-lg">
            <div className="p-3 rounded-lg bg-white border-l-4 border-[#3C2416]">
              <div className="text-xs font-semibold mb-1 opacity-75">
                Pinnacle
              </div>
              Coffee & Questions
            </div>
          </div>
        </div>

        <div className="border-b border-gray-200 pb-4">
          <div className="text-sm font-bold text-white bg-[#142841] px-3 py-2 rounded-t-lg">
            11:15 AM – 12:00 PM
          </div>
          <div className="p-3 bg-gray-50 rounded-b-lg">
            <div className="p-3 rounded-lg bg-white border-l-4 border-[#3C2416]">
              <div className="text-xs font-semibold mb-1 opacity-75">
                Pinnacle
              </div>
              Introduce Agenda
            </div>
          </div>
        </div>

        <div className="border-b border-gray-200 pb-4">
          <div className="text-sm font-bold text-white bg-[#142841] px-3 py-2 rounded-t-lg">
            12:00 – 1:00 PM
          </div>
          <div className="p-3 bg-gray-50 rounded-b-lg">
            <div className="p-3 rounded-lg bg-white border-l-4 border-[#3C2416] text-center font-bold">
              Lunch (Pinnacle)
            </div>
          </div>
        </div>

        <div className="border-b border-gray-200 pb-4">
          <div className="text-sm font-bold text-white bg-[#142841] px-3 py-2 rounded-t-lg">
            1:00 – 1:45 PM
          </div>
          <div className="space-y-2 p-3 bg-gray-50 rounded-b-lg">
            <div className="p-3 rounded-lg bg-white border-l-4 border-[#A6410A]">
              <div className="text-xs font-semibold mb-1 opacity-75">
                Pinnacle
              </div>
              ID/Fever Workgroup Symposium
            </div>
            <div className="p-3 rounded-lg bg-white border-l-4 border-[#A0B2B4]">
              <div className="text-xs font-semibold mb-1 opacity-75">
                Stowe North
              </div>
              Consensus: Gene Therapy (which person w/SCD)
            </div>
            <div className="p-3 rounded-lg bg-white border-l-4 border-[#AF8A48]">
              <div className="text-xs font-semibold mb-1 opacity-75">
                Stowe South
              </div>
              Consensus: Centers & CBO
            </div>
          </div>
        </div>

        <div className="border-b border-gray-200 pb-4">
          <div className="text-sm font-bold text-white bg-[#142841] px-3 py-2 rounded-t-lg">
            1:45 – 2:30 PM
          </div>
          <div className="space-y-2 p-3 bg-gray-50 rounded-b-lg">
            <div className="p-3 rounded-lg bg-white border-l-4 border-[#A6410A]">
              <div className="text-xs font-semibold mb-1 opacity-75">
                Pinnacle
              </div>
              ID/Fever Workgroup Symposium
            </div>
            <div className="p-3 rounded-lg bg-white border-l-4 border-[#A0B2B4]">
              <div className="text-xs font-semibold mb-1 opacity-75">
                Stowe North
              </div>
              Consensus: Gene Therapy (which person w/SCD)
            </div>
            <div className="p-3 rounded-lg bg-white border-l-4 border-[#AF8A48]">
              <div className="text-xs font-semibold mb-1 opacity-75">
                Stowe South
              </div>
              Consensus: Centers & CBO
            </div>
          </div>
        </div>

        <div className="border-b border-gray-200 pb-4">
          <div className="text-sm font-bold text-white bg-[#142841] px-3 py-2 rounded-t-lg">
            2:30 – 3:00 PM
          </div>
          <div className="space-y-2 p-3 bg-gray-50 rounded-b-lg">
            <div className="p-3 rounded-lg bg-white border-l-4 border-[#A6410A]">
              <div className="text-xs font-semibold mb-1 opacity-75">
                Pinnacle
              </div>
              ID/Fever Workgroup Symposium
            </div>
            <div className="p-3 rounded-lg bg-white border-l-4 border-[#A0B2B4]">
              <div className="text-xs font-semibold mb-1 opacity-75">
                Stowe North
              </div>
              Consensus: Gene Therapy (which person w/SCD)
            </div>
            <div className="p-3 rounded-lg bg-white border-l-4 border-[#AF8A48]">
              <div className="text-xs font-semibold mb-1 opacity-75">
                Stowe South
              </div>
              Consensus: Centers & CBO
            </div>
          </div>
        </div>

        <div className="border-b border-gray-200 pb-4">
          <div className="text-sm font-bold text-white bg-[#142841] px-3 py-2 rounded-t-lg">
            3:00 – 4:00 PM
          </div>
          <div className="space-y-2 p-3 bg-gray-50 rounded-b-lg">
            <div className="p-3 rounded-lg bg-white border-l-4 border-[#A6410A]">
              <div className="text-xs font-semibold mb-1 opacity-75">
                Pinnacle
              </div>
              ID/Fever Workgroup Symposium
            </div>
            <div className="p-3 rounded-lg bg-white border-l-4 border-[#A0B2B4]">
              <div className="text-xs font-semibold mb-1 opacity-75">
                Stowe North
              </div>
              Consensus: Gene Therapy (which person w/SCD)
            </div>
            <div className="p-3 rounded-lg bg-white border-l-4 border-[#AF8A48]">
              <div className="text-xs font-semibold mb-1 opacity-75">
                Stowe South
              </div>
              Consensus: Centers & CBO
            </div>
          </div>
        </div>

        <div className="border-b border-gray-200 pb-4 last:border-b-0">
          <div className="text-sm font-bold text-white bg-[#142841] px-3 py-2 rounded-t-lg">
            7:00 PM
          </div>
          <div className="p-3 bg-gray-50 rounded-b-lg">
            <div className="p-3 rounded-lg bg-white border-l-4 border-[#3C2416] text-center font-bold">
              Dinner on Your Own
            </div>
          </div>
        </div>
      </div>

      {/* Desktop Version */}
      <div className="hidden md:block overflow-x-auto">
        <table className="w-full border-collapse text-sm">
          <thead>
            <tr className="border-b border-[#9298a8]">
              <th className="text-center py-2 px-2 text-white font-medium bg-[#142841]">
                Time
              </th>
              <th className="text-left py-2 px-2 text-[#3C2416] font-medium">
                Pinnacle
              </th>
              <th className="text-left py-2 px-2 text-[#3C2416] font-medium">
                Stowe North
              </th>
              <th className="text-left py-2 px-2 text-[#3C2416] font-medium">
                Stowe South
              </th>
            </tr>
          </thead>
          <tbody className="text-[#3C2416]">
            <tr className="border-b border-gray-200">
              <td className="py-2 px-2 bg-[#142841] text-white font-bold text-center">
                8:00 – 9:00 AM
              </td>
              <td className="py-2 px-2 text-center font-bold" colSpan={4}>
                Breakfast (Pinnacle)
              </td>
            </tr>
            <tr className="border-b border-gray-200">
              <td className="py-2 px-2 bg-[#142841] text-white font-bold text-center">
                9:00 – 10:00 AM
              </td>
              <td className="py-2 px-2">Welcome</td>
              <td className="py-2 px-2 text-gray-400">N/A</td>
              <td className="py-2 px-2 text-gray-400">N/A</td>
            </tr>
            <tr className="border-b border-gray-200">
              <td className="py-2 px-2 bg-[#142841] text-white font-bold text-center">
                10:00 – 10:45 AM
              </td>
              <td className="py-2 px-2">NASCC Updates (Everyone)</td>
              <td className="py-2 px-2 text-gray-400">N/A</td>
              <td className="py-2 px-2 text-gray-400">N/A</td>
            </tr>
            <tr className="border-b border-gray-200">
              <td className="py-2 px-2 bg-[#142841] text-white font-bold text-center">
                10:45 – 11:15 AM
              </td>
              <td className="py-2 px-2">Coffee & Questions</td>
              <td className="py-2 px-2 text-gray-400">N/A</td>
              <td className="py-2 px-2 text-gray-400">N/A</td>
            </tr>
            <tr className="border-b border-gray-200">
              <td className="py-2 px-2 bg-[#142841] text-white font-bold text-center">
                11:15 AM – 12:00 PM
              </td>
              <td className="py-2 px-2">Introduce Agenda</td>
              <td className="py-2 px-2 text-gray-400">N/A</td>
              <td className="py-2 px-2 text-gray-400">N/A</td>
            </tr>
            <tr className="border-b border-gray-200">
              <td className="py-2 px-2 bg-[#142841] text-white font-bold text-center">
                12:00 – 1:00 PM
              </td>
              <td className="py-2 px-2 text-center font-bold" colSpan={4}>
                Lunch (Pinnacle)
              </td>
            </tr>
            <tr className="border-b border-gray-200">
              <td className="py-2 px-2 bg-[#142841] text-white font-bold text-center">
                1:00 – 1:45 PM
              </td>
              <td className="py-2 px-2 ">ID/Fever Workgroup Symposium</td>
              <td className="py-2 px-2">
                Consensus: Gene Therapy (which person w/SCD)
              </td>
              <td className="py-2 px-2">Consensus: Centers & CBO</td>
            </tr>
            <tr className="border-b border-gray-200">
              <td className="py-2 px-2 bg-[#142841] text-white font-bold text-center">
                1:45 – 2:30 PM
              </td>
              <td className="py-2 px-2">ID/Fever Workgroup Symposium</td>
              <td className="py-2 px-2">
                Consensus: Gene Therapy (which person w/SCD)
              </td>
              <td className="py-2 px-2">Consensus: Centers & CBO</td>
            </tr>
            <tr className="border-b border-gray-200">
              <td className="py-2 px-2 bg-[#142841] text-white font-bold text-center">
                2:30 – 3:00 PM
              </td>
              <td className="py-2 px-2 ">ID/Fever Workgroup Symposium</td>
              <td className="py-2 px-2">
                Consensus: Gene Therapy (which person w/SCD)
              </td>
              <td className="py-2 px-2">Consensus: Centers & CBO</td>
            </tr>
            <tr className="border-b border-gray-200">
              <td className="py-2 px-2 bg-[#142841] text-white font-bold text-center">
                3:00 – 4:00 PM
              </td>
              <td className="py-2 px-2">ID/Fever Workgroup Symposium</td>
              <td className="py-2 px-2">
                Consensus: Gene Therapy (which person w/SCD)
              </td>
              <td className="py-2 px-2">Consensus: Centers & CBO</td>
            </tr>
            <tr>
              <td className="py-2 px-2 bg-[#142841] text-white font-bold text-center">
                7:00 PM
              </td>
              <td className="py-2 px-2 text-center font-bold" colSpan={4}>
                Dinner on Your Own
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  )
}

export const FridaySchedule: React.FC = () => {
  return (
    <div
      id="friday-schedule"
      className="bg-white rounded-lg shadow-lg p-4 md:p-6"
    >
      <h3 className="sticky top-0 z-10 bg-white text-xl md:text-2xl font-serif text-[#3C2416] mb-4 py-2 -mx-4 px-4 md:static md:mx-0 md:px-0 md:py-0">
        Friday · July 25 — Consensus Results & Departures
      </h3>

      {/* Mobile Version */}
      <div className="md:hidden space-y-4">
        <div className="border-b border-gray-200 pb-4">
          <div className="text-sm font-bold text-white bg-[#142841] px-3 py-2 rounded-t-lg">
            8:00 – 9:00 AM
          </div>
          <div className="space-y-2 p-3 bg-gray-50 rounded-b-lg">
            <div className="p-3 rounded-lg bg-white border-l-4 border-[#3C2416] text-center font-bold">
              <div className="text-xs font-semibold mb-1 opacity-75">
                Pinnacle
              </div>
              Breakfast (Pinnacle)
            </div>
            <div className="p-2 text-xs text-[#3C2416] bg-blue-50 rounded border-l-4 border-blue-400">
              First shuttle for BTV departs at 8:00 AM -{' '}
              <a
                href="#shuttle-schedule"
                className="text-[#142841] underline hover:no-underline"
              >
                see shuttle schedule above
              </a>
            </div>
          </div>
        </div>

        <div className="border-b border-gray-200 pb-4">
          <div className="text-sm font-bold text-white bg-[#142841] px-3 py-2 rounded-t-lg">
            9:00 – 10:00 AM
          </div>
          <div className="p-3 bg-gray-50 rounded-b-lg">
            <div className="p-3 rounded-lg bg-white border-l-4 border-[#3C2416]">
              <div className="text-xs font-semibold mb-1 opacity-75">
                Pinnacle
              </div>
              Results from Recent Votes (SCD Specialist, Inpatient Pain Mgmt,
              Neurocognitive Surveys) (Open to Industry/All)
            </div>
          </div>
        </div>

        <div className="border-b border-gray-200 pb-4">
          <div className="text-sm font-bold text-white bg-[#142841] px-3 py-2 rounded-t-lg">
            10:00 – 10:45 AM
          </div>
          <div className="p-3 bg-gray-50 rounded-b-lg">
            <div className="p-3 rounded-lg bg-white border-l-4 border-[#3C2416]">
              <div className="text-xs font-semibold mb-1 opacity-75">
                Pinnacle
              </div>
              Consensus Results — Blood Bank & Apheresis (Open to Industry/All)
            </div>
          </div>
        </div>

        <div className="border-b border-gray-200 pb-4">
          <div className="text-sm font-bold text-white bg-[#142841] px-3 py-2 rounded-t-lg">
            10:45 – 11:15 AM
          </div>
          <div className="p-3 bg-gray-50 rounded-b-lg">
            <div className="p-3 rounded-lg bg-white border-l-4 border-[#3C2416]">
              <div className="text-xs font-semibold mb-1 opacity-75">
                Pinnacle
              </div>
              Coffee & Questions
            </div>
          </div>
        </div>

        <div className="border-b border-gray-200 pb-4">
          <div className="text-sm font-bold text-white bg-[#142841] px-3 py-2 rounded-t-lg">
            11:15 AM – 12:00 PM
          </div>
          <div className="p-3 bg-gray-50 rounded-b-lg">
            <div className="p-3 rounded-lg bg-white border-l-4 border-[#3C2416]">
              <div className="text-xs font-semibold mb-1 opacity-75">
                Pinnacle
              </div>
              Consensus Results — Gene Therapy & CBO Engagement (Open to
              Industry/All)
            </div>
          </div>
        </div>

        <div className="border-b border-gray-200 pb-4">
          <div className="text-sm font-bold text-white bg-[#142841] px-3 py-2 rounded-t-lg">
            12:00 – 1:00 PM
          </div>
          <div className="p-3 bg-gray-50 rounded-b-lg">
            <div className="p-3 rounded-lg bg-white border-l-4 border-[#3C2416] text-center font-bold">
              Lunch (Pinnacle)
            </div>
          </div>
        </div>

        <div className="border-b border-gray-200 pb-4 last:border-b-0">
          <div className="text-sm font-bold text-white bg-[#142841] px-3 py-2 rounded-t-lg">
            1:00 PM
          </div>
          <div className="space-y-2 p-3 bg-gray-50 rounded-b-lg">
            <div className="p-3 rounded-lg bg-white border-l-4 border-[#3C2416]">
              <div className="text-xs font-semibold mb-1 opacity-75">
                Pinnacle
              </div>
              Shuttles Depart for Burlington (BTV)
            </div>
            <div className="p-2 text-xs text-[#3C2416] bg-blue-50 rounded border-l-4 border-blue-400">
              <a
                href="#shuttle-schedule"
                className="text-[#142841] underline hover:no-underline"
              >
                See shuttle schedule above
              </a>
            </div>
          </div>
        </div>
      </div>

      {/* Desktop Version */}
      <div className="hidden md:grid grid-cols-[minmax(11rem,_auto)_1fr_1fr] w-full text-sm border-t border-l border-gray-300 text-[#3C2416]">
        {/* Headers */}
        <div className="text-center py-2 px-2 text-white font-bold bg-[#142841] border-b border-gray-300">
          Time
        </div>
        <div className="text-left py-2 px-2 font-bold border-b border-gray-300">
          Pinnacle
        </div>
        <div className="text-left py-2 px-2 font-bold border-b border-gray-300">
          Notes
        </div>

        {/* 8:00 – 9:00 AM */}
        <div className="py-2 px-2 bg-[#142841] text-white font-bold text-center border-b border-gray-300">
          8:00 – 9:00 AM
        </div>
        <div className="py-2 px-2 text-center font-bold border-b border-gray-300">
          Breakfast (Pinnacle)
        </div>
        <div className="py-2 px-2 border-b border-gray-300">
          First shuttle for BTV departs at 8:00 AM -{' '}
          <a
            href="#shuttle-schedule"
            className="text-[#142841] underline hover:no-underline"
          >
            see shuttle schedule above
          </a>
        </div>

        {/* 9:00 – 10:00 AM */}
        <div className="py-2 px-2 bg-[#142841] text-white font-bold text-center border-b border-gray-300">
          9:00 – 10:00 AM
        </div>
        <div className="py-2 px-2 border-b border-gray-300">
          Results from Recent Votes (SCD Specialist, Inpatient Pain Mgmt,
          Neurocognitive Surveys) (Open to Industry/All)
        </div>
        <div className="py-2 px-2 border-b border-gray-300" />

        {/* 10:00 – 10:45 AM */}
        <div className="py-2 px-2 bg-[#142841] text-white font-bold text-center border-b border-gray-300">
          10:00 – 10:45 AM
        </div>
        <div className="py-2 px-2 border-b border-gray-300">
          Consensus Results — Blood Bank & Apheresis (Open to Industry/All)
        </div>
        <div className="py-2 px-2 border-b border-gray-300" />

        {/* 10:45 – 11:15 AM */}
        <div className="py-2 px-2 bg-[#142841] text-white font-bold text-center border-b border-gray-300">
          10:45 – 11:15 AM
        </div>
        <div className="py-2 px-2 border-b border-gray-300">
          Coffee & Questions
        </div>
        <div className="py-2 px-2 border-b border-gray-300" />

        {/* 11:15 AM – 12:00 PM */}
        <div className="py-2 px-2 bg-[#142841] text-white font-bold text-center border-b border-gray-300">
          11:15 AM – 12:00 PM
        </div>
        <div className="py-2 px-2 border-b border-gray-300">
          Consensus Results — Gene Therapy & CBO Engagement (Open to
          Industry/All)
        </div>
        <div className="py-2 px-2 border-b border-gray-300" />

        {/* 12:00 – 1:00 PM */}
        <div className="py-2 px-2 bg-[#142841] text-white font-bold text-center border-b border-gray-300">
          12:00 – 1:00 PM
        </div>
        <div className="py-2 px-2 text-center font-bold col-span-2 border-b border-gray-300">
          Lunch (Pinnacle)
        </div>

        {/* 1:00 PM */}
        <div className="py-2 px-2 bg-[#142841] text-white font-bold text-center">
          1:00 PM
        </div>
        <div className="py-2 px-2">Shuttles Depart for Burlington (BTV)</div>
        <div className="py-2 px-2">
          <a
            href="#shuttle-schedule"
            className="text-[#142841] underline hover:no-underline"
          >
            See shuttle schedule above
          </a>
        </div>
      </div>
    </div>
  )
}
